// 매출
import { routeName } from '@/constants/routeName';
import basicOptions from '@/router/basic-options';
import { pageAuthorization } from '@/router-middleware';
import { userPermission } from '@/constants';
export default [
    {
        path: 'sales',
        name: routeName.SALES,
        component: () => import('@/views/Sales/index.vue'),
        redirect: {
            name: routeName.SALES_HUB_BAROMONEY,
        },
        children: [
            {
                path: 'hub-baromoney',
                name: routeName.SALES_HUB_BAROMONEY,
                component: () => import('@/views/Sales/HubBaromoney/index.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'hub-baromoney-daily-detail',
                name: routeName.SALES_HUB_BAROMONEY_DAILY_DETAIL,
                component: () => import('@/views/Sales/HubBaromoneyDailyDetail/index.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'store-baromoney',
                name: routeName.SALES_STORE_BAROMONEY,
                component: () => import('@/views/Sales/StoreBaromoney/index.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'store-baromoney-daily-detail',
                name: routeName.SALES_STORE_BAROMONEY_DAILY_DETAIL,
                component: () => import('@/views/Sales/StoreBaromoneyDailyDetail/index.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'invoice',
                name: routeName.SALES_INVOICE,
                component: () => import('@/views/Sales/Invoice/index.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_HUB_SALES,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
        ],
    },
];
